import React from "react";
import Icon, { CloseOutlined } from "@ant-design/icons";
import { getTranslation } from "../../utils/helper";

const ArrowRight = () => (
  <svg viewBox="0 0 448 512">
    <path
      fill="currentColor"
      d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"
      className=""></path>
  </svg>
);

const StepPopupUnassign = ({ step, stepPopover, setStepsHovered, onClickStep, setting }) => {
  const handleClose = () => {
    setStepsHovered({ [stepPopover]: false });
  };

  const handleClick = () => {
    onClickStep(step.orderId, step.type.toLowerCase() === "pickup" ? "delivery" : "pickup");
  };

  return (
    <div className="step-popup">
      <a className="btn-close" onClick={handleClose}>
        <CloseOutlined />
      </a>
      <p>
        <strong>
          [
          {step.type.toLowerCase() === "pickup"
            ? getTranslation(setting, "Orders", "Pickup")
            : getTranslation(setting, "Orders", "Delivery")}
          ]
        </strong>
      </p>
      {step.routePlanType === "PDP" && (
        <div className="actions">
          <a onClick={handleClick} style={{ marginLeft: 20 }}>
            {getTranslation(setting, "Common", "Go to")}{" "}
            {step.type.toLowerCase() === "pickup"
              ? getTranslation(setting, "Orders", "Delivery")
              : getTranslation(setting, "Orders", "Pickup")}
            <Icon
              component={ArrowRight}
              style={{
                width: 10,
                marginLeft: 5,
              }}
            />
          </a>
        </div>
      )}
    </div>
  );
};

export default StepPopupUnassign;
